import ScrollReveal from '@/components/base/ScrollReveal';
import RiskZoneChart from '@/pages/risk-management/components/RiskZoneChart';
import { riskChartCandles, riskDiagram } from '@/mocks/riskManagementPage';

const toneMap = {
  foreground: { bar: 'bg-foreground-400', text: 'text-foreground-700' },
  accent: { bar: 'bg-accent-500', text: 'text-accent-800' },
  primary: { bar: 'bg-primary-500', text: 'text-primary-800' },
  secondary: { bar: 'bg-secondary-500', text: 'text-secondary-900' },
};

export default function RiskDiagram() {
  return (
    <section
      id="risk-diagram"
      className="scroll-mt-[7.5rem] border-b border-background-200 bg-background-50 md:scroll-mt-[9rem]"
    >
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between md:gap-12">
          <div className="max-w-2xl">
            <span className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-600">
              <span className="h-px w-6 bg-accent-500" />
              แผนภาพเพื่อการเรียนรู้
            </span>
            <h2 className="text-balance font-heading text-2xl font-semibold leading-tight text-foreground-950 md:text-[34px]">
              เข้าใจความเสี่ยงก่อนเปิดคำสั่งซื้อขาย
            </h2>
          </div>
          <p className="max-w-sm text-xs leading-relaxed text-foreground-600 md:pb-2">
            ก่อนกดออเดอร์ ควรตอบได้ว่าจุดเข้าอยู่ไหน คิดผิดที่ไหน และหวังผลที่ไหน
            เพราะตัวเลขสามจุดนี้กำหนดความเสี่ยงและผลตอบแทนทั้งออเดอร์
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-[1.28fr_0.72fr] lg:gap-10">
          <ScrollReveal as="div">
            <figure className="rounded-xl border border-background-200 bg-background-50 p-3 md:p-4">
              <div className="flex flex-wrap items-center justify-between gap-2 border-b border-background-200 pb-3">
                <div className="flex items-center gap-2">
                  <span className="font-num text-sm font-semibold text-foreground-950">EUR/USD</span>
                  <span className="rounded-sm bg-background-100 px-1.5 py-0.5 font-num text-[10px] font-semibold text-foreground-600">
                    H1
                  </span>
                  <span className="text-[11px] text-foreground-500">ตัวอย่างแผนออเดอร์</span>
                </div>
                <span className="rounded-full bg-background-100 px-2 py-0.5 text-[10px] font-medium text-foreground-600">
                  กราฟสมมติ
                </span>
              </div>

              <div className="mt-3">
                <RiskZoneChart
                  candles={riskChartCandles}
                  entry={riskDiagram.entry}
                  stopLoss={riskDiagram.stopLoss}
                  takeProfit={riskDiagram.takeProfit}
                  ariaLabel="แผนภาพกราฟตัวอย่าง แสดงจุดเข้า เส้น Stop Loss ด้านล่าง เส้น Take Profit ด้านบน พร้อมช่วงความเสี่ยงและช่วงผลตอบแทนตามแผน"
                  heightClass="h-[300px] sm:h-[360px] lg:h-[380px]"
                />
              </div>

              <figcaption className="mt-3 border-t border-background-200 pt-3 text-[11px] leading-relaxed text-foreground-500">
                {riskDiagram.note}
              </figcaption>
            </figure>
          </ScrollReveal>

          <div className="flex flex-col">
            <ul className="flex flex-col divide-y divide-background-200 border-y border-background-200">
              {riskDiagram.legend.map((item, index) => (
                <ScrollReveal as="li" key={item.label} delay={index * 60} className="py-4">
                  <div className="flex items-center gap-2.5">
                    <span className={`h-0.5 w-6 shrink-0 ${toneMap[item.tone].bar}`} aria-hidden="true" />
                    <h3 className={`font-heading text-sm font-semibold ${toneMap[item.tone].text}`}>{item.label}</h3>
                  </div>
                  <p className="mt-1.5 pl-8 text-[12px] leading-relaxed text-foreground-600">{item.body}</p>
                </ScrollReveal>
              ))}
            </ul>

            <div className="mt-5 flex items-start gap-2.5 rounded-lg border border-background-200 bg-background-100/70 p-4">
              <i className="ri-information-line mt-0.5 shrink-0 text-base text-foreground-500" aria-hidden="true" />
              <p className="text-[11px] leading-relaxed text-foreground-600">
                แผนภาพนี้ไม่ใช่เครื่องมือให้สัญญาณซื้อขาย ไม่ได้บอกให้เข้าหรือออกที่ระดับใด
                และไม่ใช่การคาดการณ์ทิศทางราคาในอนาคต
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}